import lang from '@/lang'
import { PERIODS } from '@/modules/vatReturn/constants'
import moment from 'moment'

export const periodMap = new Map([
  [PERIODS.QUARTER1, lang.vatReturn.periods.quarter1],
  [PERIODS.QUARTER2, lang.vatReturn.periods.quarter2],
  [PERIODS.QUARTER3, lang.vatReturn.periods.quarter3],
  [PERIODS.QUARTER4, lang.vatReturn.periods.quarter4],
  [PERIODS.YEAR, lang.vatReturn.periods.year],
  [PERIODS.JANUARY, lang.vatReturn.periods.january],
  [PERIODS.FEBRUARY, lang.vatReturn.periods.february],
  [PERIODS.MARCH, lang.vatReturn.periods.march],
  [PERIODS.APRIL, lang.vatReturn.periods.april],
  [PERIODS.MAY, lang.vatReturn.periods.may],
  [PERIODS.JUNE, lang.vatReturn.periods.june],
  [PERIODS.JULY, lang.vatReturn.periods.july],
  [PERIODS.AUGUST, lang.vatReturn.periods.august],
  [PERIODS.SEPTEMBER, lang.vatReturn.periods.september],
  [PERIODS.OCTOBER, lang.vatReturn.periods.october],
  [PERIODS.NOVEMBER, lang.vatReturn.periods.november],
  [PERIODS.DECEMBER, lang.vatReturn.periods.december],
])

export const translatePeriod = (period) => {
  return periodMap.get(period)
}

export const INTERVAL_OPTIONS_VAT_RETURN = [
  { value: 'month', label: lang.vatReturn.form.intervalOptions.month },
  { value: 'quarter', label: lang.vatReturn.form.intervalOptions.quarter },
]

export const INTERVAL_OPTIONS = [
  ...INTERVAL_OPTIONS_VAT_RETURN,
  { value: 'year', label: lang.vatReturn.form.intervalOptions.year },
]

export const MONTH_OPTIONS = [
  { value: PERIODS.JANUARY, label: translatePeriod(PERIODS.JANUARY) },
  { value: PERIODS.FEBRUARY, label: translatePeriod(PERIODS.FEBRUARY) },
  { value: PERIODS.MARCH, label: translatePeriod(PERIODS.MARCH) },
  { value: PERIODS.APRIL, label: translatePeriod(PERIODS.APRIL) },
  { value: PERIODS.MAY, label: translatePeriod(PERIODS.MAY) },
  { value: PERIODS.JUNE, label: translatePeriod(PERIODS.JUNE) },
  { value: PERIODS.JULY, label: translatePeriod(PERIODS.JULY) },
  { value: PERIODS.AUGUST, label: translatePeriod(PERIODS.AUGUST) },
  { value: PERIODS.SEPTEMBER, label: translatePeriod(PERIODS.SEPTEMBER) },
  { value: PERIODS.OCTOBER, label: translatePeriod(PERIODS.OCTOBER) },
  { value: PERIODS.NOVEMBER, label: translatePeriod(PERIODS.NOVEMBER) },
  { value: PERIODS.DECEMBER, label: translatePeriod(PERIODS.DECEMBER) },
]

export const QUARTER_OPTIONS = [
  { value: PERIODS.QUARTER1, label: translatePeriod(PERIODS.QUARTER1) },
  { value: PERIODS.QUARTER2, label: translatePeriod(PERIODS.QUARTER2) },
  { value: PERIODS.QUARTER3, label: translatePeriod(PERIODS.QUARTER3) },
  { value: PERIODS.QUARTER4, label: translatePeriod(PERIODS.QUARTER4) },
]

export const getYearOptions = (withOneYearPlus) => {
  const options = []

  for (let i = 0; i <= 10; i++) {
    const year
      = withOneYearPlus
        ? moment().add(1, 'years').subtract(i, 'year').year().toString()
        : moment().subtract(i, 'year').year().toString()
    options.push({
      label: year,
      value: year,
    })
  }

  return options
}

export const getPeriodOptions = (interval) => {
  switch (interval) {
    case 'quarter':
      return QUARTER_OPTIONS
    case 'month':
      return MONTH_OPTIONS
    default:
      return []
  }
}

const periodMonthNumberMap = new Map([
  [PERIODS.JANUARY, 0],
  [PERIODS.FEBRUARY, 1],
  [PERIODS.MARCH, 2],
  [PERIODS.APRIL, 3],
  [PERIODS.MAY, 4],
  [PERIODS.JUNE, 5],
  [PERIODS.JULY, 6],
  [PERIODS.AUGUST, 7],
  [PERIODS.SEPTEMBER, 8],
  [PERIODS.OCTOBER, 9],
  [PERIODS.NOVEMBER, 10],
  [PERIODS.DECEMBER, 11],
])

const periodQuarterNumberMap = new Map([
  [PERIODS.QUARTER1, 1],
  [PERIODS.QUARTER2, 2],
  [PERIODS.QUARTER3, 3],
  [PERIODS.QUARTER4, 4],
])

export const getPeriodByMonthNumber = (month) => {
  let period = null
  periodMonthNumberMap.forEach((value, key) => {
    if (value === month) {
      period = key
    }
  })
  return period
}

export const getPeriodByQuarterNumber = (quarter) => {
  let period = null
  periodQuarterNumberMap.forEach((value, key) => {
    if (value === quarter) {
      period = key
    }
  })
  return period
}

export const getMonthNumberByPeriod = (period) => {
  return periodMonthNumberMap.get(period) ?? -1
}

export const getQuarterNumberByPeriod = (period) => {
  return periodQuarterNumberMap.get(period) ?? -1
}

export const getNumberByPeriod = (period) => {
  return periodMonthNumberMap.get(period) ?? periodQuarterNumberMap.get(period) ?? -1
}

export const getStartAndEndDate = (period, year) => {
  let startDate, endDate
  switch (period) {
    case PERIODS.QUARTER1:
      startDate = moment.utc().month(0).year(year).startOf('month')
      endDate = moment.utc().month(2).year(year).endOf('month')
      break
    case PERIODS.QUARTER2:
      startDate = moment.utc().month(3).year(year).startOf('month')
      endDate = moment.utc().month(5).year(year).endOf('month')
      break
    case PERIODS.QUARTER3:
      startDate = moment.utc().month(6).year(year).startOf('month')
      endDate = moment.utc().month(8).year(year).endOf('month')
      break
    case PERIODS.QUARTER4:
      startDate = moment.utc().month(9).year(year).startOf('month')
      endDate = moment.utc().month(11).year(year).endOf('month')
      break
    case PERIODS.YEAR:
      startDate = moment.utc().year(year).startOf('year')
      endDate = moment.utc().year(year).endOf('year')
      break

    default:
      startDate = moment.utc().month(periodMonthNumberMap.get(period)).year(year).startOf('month')
      endDate = moment.utc().month(periodMonthNumberMap.get(period)).year(year).endOf('month')
      break
  }
  return {
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString(),
  }
}
